import React from 'react'
import classNames from 'classnames'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import RadioButton from 'src/components/Elements/Inputs/RadioButton'

const PartnerFollowUpQuestion = ({ radioValue, setRadioValue, session }) => {
  const radioOptions = [
    { id: 1, value: true, name: 'Yes' },
    { id: 2, value: false, name: 'No' }
  ]
  const radioOptionsLong = [
    { id: 1, value: true, name: 'Yes, I would like a Gartner specialist to contact me about becoming a client.' },
    { id: 2, value: false, name: 'No, I do not want to learn about how I can gain access to Gartner insights and experts.' }
  ]

  const fumQuestionText = session?.session_type_key?.startsWith('session_type_gartner_')
    ? 'Want to learn about how Gartner insights and experts can help you achieve your business critical priorities?'
    : 'Would you like to continue the conversation with the speaker(s) from this session?'

  const optionsToUse = session?.session_type_key?.startsWith('session_type_gartner_')
    ? radioOptionsLong
    : radioOptions

  return (
    <>
      <div className={classNames(generalStyles.mt30, generalStyles.mb20)}>
        <span className={fontStyles.psmallboldlsinneutral08onyxgartnersans15pt}>
          {fumQuestionText}
        </span>
      </div>
      <div
        className={classNames(generalStyles.flexColumn, generalStyles.gap10)}
      >
        {optionsToUse?.map((opt) => (
          <RadioButton
            key={`radio-cmpt-${opt.id}`}
            id={opt.id}
            label={opt.name}
            selected={radioValue === opt.value}
            onClick={() => setRadioValue(opt.value)}
            value={opt.value}
          />
        ))}
      </div>
    </>
  )
}

export default PartnerFollowUpQuestion
